import { Route, Navigate, useLocation } from 'react-router-dom';
import React from "react";
import { usePermission } from './CheckAccess';

const PrivateRouter = ({ element, ...rest }) => {
  const { setCheckAccess } = usePermission();  
  const menus = JSON.parse(localStorage.getItem('userDet'))?.entService || [];

  const matchService = (url) => {
    const findService = (services) => {
      if (!Array.isArray(services)) return null;

      for (let service of services) {
        if (service.resourceAction === url) {
          return service;
        }
        if (Array.isArray(service.subMenu) && service.subMenu.length > 0) {
          const foundInSubMenu = findService(service.subMenu);
          if (foundInSubMenu) {
            return foundInSubMenu;
          }
        }
      }
      return null;
    };
    return findService(menus);
  };

  const matchedService = matchService(useLocation().pathname);
  const hasReadAccess = matchedService?.readAccess;

  localStorage.setItem('checkAccess', JSON.stringify(matchedService));

  return hasReadAccess ? element : <Navigate to="/access-denied" />;
};

export default PrivateRouter;
